import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalSucessoRemoverProcessos({ show, handleClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Remover processo"
      centered={true}
      footer={false}
      footerConfirmButton={false}
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        Processo(s) removido(s) do lote de pagamento!
      </ModalBody>
    </ModalCustom>
  );
}
